import React from 'react';

const images = [
    '/landing/1771403310121.png',
    '/landing/1771403734843.png',
    '/landing/1771404204587.png',
    '/landing/1771404337558.png',
    '/landing/edit-1771839388377.png',
    '/landing/edit-1771839729603.png',
    '/landing/edit-1771839832874.png',
    '/landing/edit-1771839937137.png',
    '/landing/edit-1771840002697.png',
];

export const ImageMarquee: React.FC = () => {
    return (
        <div className="w-full overflow-hidden py-10 group">
            <div className="relative flex overflow-x-hidden">
                <div className="py-12 animate-marquee whitespace-nowrap flex gap-8">
                    {/* Double the list for infinite scroll illusion */}
                    {[...images, ...images].map((src, index) => (
                        <div
                            key={index}
                            className="inline-block w-[400px] h-[250px] relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl transition-all duration-500 hover:scale-110 hover:shadow-[0_0_30px_rgba(99,102,241,0.5)] hover:border-indigo-500/50 hover:z-10 cursor-pointer"
                        >
                            <img
                                src={src}
                                alt={`Showcase ${index}`}
                                className="w-full h-full object-cover"
                            />
                            {/* Hover Overlay */}
                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                                <span className="text-white font-medium text-sm tracking-widest bg-indigo-600/90 px-3 py-1 rounded-full backdrop-blur-sm">
                                    AI GENERATED
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Gradient Masks */}
            <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-black via-black/80 to-transparent z-10 pointer-events-none" />
            <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-black via-black/80 to-transparent z-10 pointer-events-none" />

            <style>{`
                .animate-marquee {
                    animation: marquee 40s linear infinite;
                }
                .group:hover .animate-marquee {
                    animation-play-state: paused;
                }
                @keyframes marquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
            `}</style>
        </div>
    );
};
